import './App.css';
import Register from './Components/Register/Register';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import ResetPassword from './Components/ResetPassword/Resetpassword';
import Courses from './Components/Courses/Courses';
import LoginPage from './Components/LoginPage/LoginPage';
import CourseDetails from './Components/CourseDetails/CourseDetails';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import BlogPage from './Components/Footer/BlogPage.js';
import SearchResultsPage from './Components/SearchResultsPage/SearchResultsPage';
import EnrolledCourse from './Components/EnrolledCourses/EnrolledCourse';
import EnrolledCourses from './Components/EnrolledCourses/EnrolledCourses';
import AccountPage from './Components/Profile/AccountPage';
import ProgressBar from './Components/ProgressBar/ProgressBar';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import '@fontsource/inter';
import '@fontsource/playfair-display/400.css';
import '@fontsource/source-serif-pro/400.css';
import '@fontsource/poppins';
import AddCourse from './Instructor/AddCourse';
import Cart from './Components/CheckOut/Cart';
import MainDashboard from './Components/MainDashboard/MainDashboard';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import ScrollToTop from './ScrollToTop';
import Wishlist from './Components/Profile/Wishlist';
import CategoriesCourses from './Components/Navbar/CategoriesCourses';
import QuizCreation from './Instructor/QuizCreation';
import SupportPage from './Components/Support/SupportPage';
import Certificate from './Components/EnrolledCourses/Certificate';
import EmailUpdateVerfication from './Components/LoginPage/EmailUpdateVerfication';
import ViewQRCertificationDetails from './Components/EnrolledCourses/ViewQRCertificationDetails';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PageNotFound from './Components/PageNotFound/PageNotFound';
import TermsAndConditions from './Components/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './Components/TermsAndConditions/PrivacyPolicy';
import UseTokenValidator from './UseTokenValidator';
import RefundPolicy from './Components/TermsAndConditions/RefundPolicy';
import RazorPay from './Components/CheckOut/RazorPay';
import PremiumCourses from './Components/Courses/PremiumCourses';
import CodeInterpreter from './Components/CodeInterpreter';
import AIInterviewLanding from './Components/AiInterview/AIInterviewEnrolledCourse/AIInterviewLanding';
import AIInterviewExam from './Components/AiInterview/AIInterviewEnrolledCourse/AIInterviewExam';
import AIInterviewResult from './Components/AiInterview/AIInterviewEnrolledCourse/AIInterviewResult';
import QuestionEditor from './Components/AiInterview/AIInterviewEnrolledCourse/QuestionEditor';
import AboutUs from './Components/Support/AboutUs';
import SiteMap from './Components/Support/SiteMap';
import InterviewConfidenceLevel from './Components/AiInterview/AIInterviewEnrolledCourse/InterviewConfidenceLevel ';
import InterviewAccuracy from './Components/AiInterview/AIInterviewEnrolledCourse/InterviewAccuracy ';
import AiInterviewUnenrolledCourse from './Components/AiInterview/AIInterviewUnenrolledCourse/AiInterviewUnenrolledCourse';
import AIInterviewLandingUnenrolledCourse from './Components/AiInterview/AIInterviewUnenrolledCourse/AIInterviewLandingUnenrolledCourse';
import ExamEnded from './Components/AiInterview/AIInterviewEnrolledCourse/ExamEnded';
import AIInterviewExamUnenrolledCourse from './Components/AiInterview/AIInterviewUnenrolledCourse/AIInterviewExamUnenrolledCourse';
import AIInterviewResultUnenrolledCourse from './Components/AiInterview/AIInterviewUnenrolledCourse/AIInterviewResultUnenrolledCourse';
import ExamEndedUnenrolledCourse from './Components/AiInterview/AIInterviewUnenrolledCourse/ExamEndedUnenrolledCourse';
import NavbarExam from './Components/Navbar/NavbarExam';
import FeedbackPopup from './Components/AiInterview/AIInterviewEnrolledCourse/Feedback';
import ResumeLanding from './Components/ResumeAnalyzer/ResumeLanding';
import ResumeEditor from './Components/ResumeAnalyzer/ResumeEditor';
import ApplyJobs from './Components/ApplyJobs/ApplyJobs';
import PaymentSuccessPage from './Components/CheckOut/PaymentSuccessPage';
import InterviewRequestPage from './Components/InstructorInterview/InterviewRequestPage';
import UnenrolledAIInterviewPayment from './Components/InstructorInterview/UnenrolledAIInterviewPayment';
import InterviewConfirmation from './Components/InstructorInterview/InterviewConfirmation';
import TrainingForm from './Components/MainDashboard/TrainingForm';
import BlogsPage from './Components/Footer/BlogPage.js';
import FestivaSalelBanner from './Components/SaleBanner/FestivalSaleBanner.js';

function App() {
  const location = useLocation();

  const hideNavbarRoutes = [
    "/enrolledCourse/ai-interview/:id/:courseName/exam",
    "/unenrolled-ai-interview/:courseName/:experience/exam"
  ];

  const shouldHideNavbar = hideNavbarRoutes.some(route => {
    const regex = new RegExp(`^${route.replace(/:[^\s/]+/g, '([^/]+)')}$`);
    return regex.test(location.pathname);
  });




  return (
    <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
      <PayPalScriptProvider deferLoading={true}>

        <ScrollToTop />
        {!shouldHideNavbar ? <Navbar /> : <NavbarExam />}
        <UseTokenValidator />
        <Routes>
          {/* <Route path='/resume-check' element={<ResumeLanding />} /> */}

          <Route path='/' element={<MainDashboard />} />
          <Route path='/register' element={<Register />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/resetpassword' element={<ResetPassword />} />
          {/* <Route path='/coursedetails/:courseId' element={<CourseDetails />} /> */}
          {/* <Route path='/courses/:slug' element={<CourseDetails />} /> */}
          <Route path="/courses/:slug" element={<CourseDetails />} />
          <Route path="/coursedetails/:courseId" element={<CourseDetails />} /> {/* Optional legacy support */}

          <Route path='/search' element={<SearchResultsPage />} />
          <Route path='/career-placement-assistance' element={<PremiumCourses />} />
          <Route path='/enrolledCourse/:id' element={<EnrolledCourse />} />

          <Route path="/enrolledCourse/ai-interview/:id/:courseName" element={<AIInterviewLanding />} />
          <Route path="/enrolledCourse/ai-interview/:id/:courseName/exam" element={<AIInterviewExam />} />
          <Route path="/enrolledCourse/ai-interview/:id/:courseName/result" element={<AIInterviewResult />} />
          <Route path="/enrolledCourse/ai-interview/:id/:courseName/exam-ended" element={<ExamEnded />} />
          <Route path="/:id/interview-confidence-level" element={<InterviewConfidenceLevel />} />
          <Route path="/:id/interview-accuracy" element={<InterviewAccuracy />} />

          <Route path='instructor-interview' element={<UnenrolledAIInterviewPayment />} /> 

          <Route path='/ai-interview' element={<AiInterviewUnenrolledCourse />} />
          <Route path="/unenrolled-ai-interview/:courseName/:experience" element={<AIInterviewLandingUnenrolledCourse />} />
          <Route path="/unenrolled-ai-interview/:courseName/:experience/exam" element={<AIInterviewExamUnenrolledCourse />} />
          <Route path="/unenrolled-ai-interview/:courseName/:experience/result" element={<AIInterviewResultUnenrolledCourse />} />
          <Route path="/unenrolled-ai-interview/:courseName/:experience/exam-ended" element={<ExamEndedUnenrolledCourse />} />

          <Route path='/feedback' element={<FeedbackPopup />} />
          <Route path='/enrolledCourses' element={<EnrolledCourses />} />
          <Route path='/mycourse' element={<ProgressBar />} />
          <Route path='/profile' element={<AccountPage />} />
          <Route path='/add-course' element={<AddCourse title="Add Course" />} />
          <Route path='/checkOut' element={<RazorPay />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/wishlist' element={<Wishlist />} />
          <Route path="/categories" element={<CategoriesCourses />} />
          <Route path="/quiz-creation/:id" element={<QuizCreation />} />
          <Route path='/contact' element={<SupportPage />} />
          <Route path='/certificate' element={<Certificate />} />
          <Route path='/verify-email' element={<EmailUpdateVerfication />} />
          <Route path='/certificate/:userId/:courseId' element={<ViewQRCertificationDetails />} />
          <Route path='/terms-conditions' element={<TermsAndConditions />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/refund-policy' element={<RefundPolicy />} />
          {/* <Route path='/video-record' element={<VideoRecord />} /> */}
          <Route path='/arena' element={<CodeInterpreter />} />
          <Route path='/question' element={<QuestionEditor />} />
          <Route path='/sitemap' element={<SiteMap />} />
          <Route path='/about' element={<AboutUs />} />
          <Route path='/apply-jobs' element={<ApplyJobs />} />

          <Route path="/payment-success" element={<PaymentSuccessPage />} />

          <Route path='/instructor-interview-request' element={<InterviewRequestPage />} />

        <Route path='/interview-confirmation' element={<InterviewConfirmation/>} />

        <Route path='/live-classes-form' element={<TrainingForm />} />

        <Route path='blog' element={<BlogPage />} />

          <Route path='*' element={<PageNotFound />} />
        </Routes>
        {!shouldHideNavbar && <Footer />}
      </PayPalScriptProvider>
    </GoogleOAuthProvider>
  );
}

export default App;  